// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1kHij","title":"Info_title__3zqEP","selects":"Info_selects__3utAd","requiredAsterisk":"Info_requiredAsterisk__sJEnp"};